import React, {Component} from 'react';
import {Field} from 'redux-form'

// import VirtualizedSelect from 'react-virtualized-select'
// import Select,{Creatable} from 'react-select'
import Select, {createFilter} from 'react-select'
import Creatable, {useCreatable} from 'react-select/creatable';

import {
    LowerCaseSanitizer,
    AllSubstringsIndexStrategy,
    StemmingTokenizer,
    TfIdfSearchIndex
} from 'js-search'

import {jsastem} from '../services/Stemmer'

import {stemmer} from 'porter-stemmer'

import createFilterOptions from 'react-select-fast-filter-options'


// import 'react-select/dist/react-select.css';
// import 'react-virtualized/styles.css'
// import 'react-virtualized-select/styles.css'

import {locale} from '../locale/AppLocale';
import Editor from './Editor';
import DropZone from '../Components/DropZone';
import {GetEntityAttribute} from "../Helpers/Entity";


class CustomTokenizer implements ITokenizer {
    tokenize(text) {
        let tokenizedText = text
            .split(" ")
            .map((text) => (
                jsastem(text)
            ))
            .filter(
                (text) => text // Filter empty tokens
            );


        return tokenizedText
    }
};

const indexStrategy = new AllSubstringsIndexStrategy()

const sanitizer = new LowerCaseSanitizer()


const tokenizer = new StemmingTokenizer(stemmer, new CustomTokenizer())


const renderPlainField = ({input, placeholder, type, disabled, meta: {touched, error}}) => (
    <div className={`form-group input-c input-c--plain ` + (touched && error ? `has-error` : ``)}>
        <input {...input} disabled={disabled} placeholder={placeholder} className="input" type={type}/>
        {touched
            && ((error && <span className="help-block is-error">{error}</span>))}
    </div>
);

export default class ProductInput extends Component {

    render() {

        let input = null;

        if (this.props.field.data_type === 'dropdown') {
            input = <CustomField {...this.props} />;
        } else if (this.props.field.data_type === 'bool') {
            input = <Boolean {...this.props} />;
        } else if (this.props.field.data_type === 'dropzone' || this.props.type === 'dropzone') {
            input = <DropZone disabled={this.props.disabled} inputProps={this.props} name={this.props.input.name}/>;
        } else if (this.props.field.data_type === 'textarea' || this.props.type === 'textarea') {
            input = <Editor value={this.props.input.value} disabled={this.props.disabled} id={this.props.id}
                            onChange={this.props.input.onChange}/>
        } else {
            input = <input
                {...this.props.input}
                id={this.props.id}
                disabled={this.props.disabled}
                className={(this.props.type === 'checkbox' || this.props.type === 'radio') ? '' : 'input'}
                placeholder={this.props.placeholder}
                type={this.props.type}/>;
        }

        return (
            <div className={`input-c ` + (this.props.meta.touched && this.props.meta.error ? `has-error` : ``)}>
                {this.props.label && this.props.label.length > 0 ? (
                    <label htmlFor={this.props.id}
                           className={'label ' + (this.props.field.is_required ? ' label--required ' : '')}>
                        {this.props.label} {this.props.field.is_variant ? 'is Variant' : ''}
                    </label>
                ) : ('')}

                <div className={`input-type-wrapper input-type-` + this.props.type}>
                    {this.props.alt_label && <label className="alt-label label">
                        {input}
                        {this.props.alt_label}
                    </label>}
                    {!this.props.alt_label && input}
                    {this.props.meta.touched
                        && ((this.props.meta.error &&
                                <span className="help-block is-error">{this.props.meta.error}</span>)
                            || (this.props.meta.warning && <span>{this.props.meta.warning}</span>))}
                </div>
                <div className="clearfix"></div>
            </div>
        )
    }
}

class CustomField extends Component {

    render() {
        if (this.props.field && this.props.field.data_type !== 'dropdown') {
            return null;
        }
        const inputProps = this.props.input;

        if (!this.props.meta.touched) {
            if (!inputProps.value || inputProps.value.length === 0) {
                // inputProps.value = null;
            } else {
                let valueExists = false;
                let options = this.formatSelectOptions();
                options.forEach((option, index) => {
                    if (valueExists === true) {
                        return;
                    }
                    if (option.value === inputProps.value && option.field === this.props.field.name) {
                        valueExists = true;
                        return option;
                    }
                });
                if (valueExists === false) {
                    // inputProps.value = null;
                }
            }
        }
        const options = this.formatSelectOptions();

        const searchIndex = new TfIdfSearchIndex()
        const filterOptions = createFilterOptions({
            indexStrategy,
            options,
            sanitizer,
            searchIndex,
            tokenizer
        });
        // const filterConfig = {
        //     ignoreCase: true,
        //     ignoreAccents: true,
        //     trim: true,
        //     matchFrom: false,
        // };
        // const filterOptions = createFilter(filterConfig);

        //
        let inputPropsValue = inputProps.value;
        if (inputPropsValue && typeof inputPropsValue !== 'object') {
            const idx = options.findIndex(opt => opt.value === inputProps.value);
            if (idx !== -1) {
                inputPropsValue = options[idx];
            }

        }
        inputProps.value = inputPropsValue;

        if (this.props.field.is_variant === true) {
            return (
                <div>
                    {/*<VirtualizedSelect*/}
                    <Select
                        selectComponent={Creatable}
                        {...inputProps}
                        id={this.props.id}
                        options={options}
                        filterOptions={filterOptions}
                        onBlur={null}
                        multi={this.props.field.is_variant === true}
                        keepOpen={true}
                        allowCreate={true}
                        ref="select"
                        onChange={this.onSelectChange.bind(this)}
                        disabled={this.props.disabled}
                        simpleValue={this.props.field.is_variant !== true}
                        shouldKeyDownEventCreateNewOption={({keyCode}) => keyCode === 13}
                        promptTextCreator={(label) => {
                            return locale.get('add_option') + ' ' + label;
                        }}
                        newOptionCreator={({label, labelKey, valueKey}) => {
                            const option = {
                                id: label,
                                name: label,
                                field: this.props.field.name,
                                group_id: this.props.field.group_id,
                                attribute_id: this.props.field.id,
                                label: label,
                            }
                            option[valueKey] = label
                            option[labelKey] = label
                            return option;
                        }}
                        placeholder={locale.get('choose')}/>

                    {this.props.field.is_variant === false
                        && this.props.field.has_other === true
                        && inputProps.value === -1
                        &&
                        <Field
                            type="text"
                            component={renderPlainField}
                            name={this.props.field.name + `_other`}
                            className="input"
                            placeholder={locale.get('specify_your_own')}/>}
                </div>
            )
        } else {
            let SelectComponent
            if (options.length > 20) {
                // SelectComponent = VirtualizedSelect
                SelectComponent = Select
            } else {
                SelectComponent = Select
            }

            return (
                <div>


                    <SelectComponent
                        filterOptions={filterOptions}
                        {...inputProps}
                        value={inputPropsValue}
                        id={this.props.id}
                        options={options}
                        onBlur={null}
                        multi={this.props.field.is_variant === true}
                        keepOpen={false}
                        allowCreate={false}
                        ref="select"
                        onChange={this.onSelectChange.bind(this)}
                        disabled={this.props.disabled}
                        simpleValue={this.props.field.is_variant !== true}
                        placeholder={locale.get('choose')}/>

                    {this.props.field.is_variant === false
                        && this.props.field.has_other === true
                        && inputProps.value === -1
                        &&
                        <Field
                            type="text"
                            component={renderPlainField}
                            name={this.props.field.name + `_other`}
                            className="input"
                            placeholder={locale.get('specify_your_own')}/>}
                </div>
            )
        }

    }


    formatSelectOptions() {

        if (this.props.field.selectOptions) {
            return this.props.field.selectOptions || [];
        } else {

            const final = [];
            let groupId = this.props.field.group_id;
            let attributeId = this.props.field.id;

            this.props.field.options.forEach((item) => {
                final.push({
                    value: item.id,
                    label: GetEntityAttribute(item,'title'),
                    group_id: groupId,
                    attribute_id: attributeId,
                    field: this.props.field.name
                })
                //@TODO after Ramadan ,,, this called a lot ... literally a lot
                // console.log(item.id,this.props.field.name)
            });

            if (this.props.field.is_variant === false && this.props.field.has_other === true) {
                final.push({
                    value: -1,
                    label: locale.get('specify_your_own'),
                    field: this.props.field.name,
                    group_id: groupId,
                    attribute_id: attributeId,
                })
            }
            return final;
        }
    };

    onSelectChange(value, data) {
        // this.refs.select.closeMenu();
        this.props.input.onChange(value);

        console.log('this.props.input@', this.props.input, value, data)

        if (value === -1) {

        }
    }


    shouldComponentUpdate(nextProps, nextState) {
        if (
            (!nextProps.input.value && !this.props.input.value)
            || nextProps.input.value === this.props.input.value
        ) {
            return false;
        }
        return true;
    }

}

class Boolean extends React.Component {


    render() {
        return (
            <div>
                <Radio {...this.props} label={locale.get('yes')} value={1}/>
                <Radio {...this.props} label={locale.get('no')} value={0}/>
            </div>
        )
    }

}

class Radio extends React.Component {
    render() {
        let savedValue = parseInt(this.props.input.value, 10) ? 1 : 0;
        return (
            <label className="control control--radio">
                <input
                    {...this.props.input}
                    id={this.props.id}
                    disabled={this.props.disabled}
                    className='radio'
                    placeholder={this.props.placeholder}
                    value={this.props.value}
                    defaultChecked={this.props.value === savedValue}
                    type="radio"/>
                <div className="control__indicator"></div>
                {this.props.label}
            </label>
        )
    }
}